import React, { Component } from 'react';
import Phone from './Phone'
import Email from './Email'
import EditContactPerson from '../serviceCall/EditContactPerson';

class ContactPersons extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.state= { mode: "" };
    }

    closeDetails() {
        this.setState({mode:""});
    }

    edit (cp) { 
        this.setState({mode:"edit", currentEdit:cp});
    }

    render() {
        var enableEdit = this.props.enableEdit === true;
        const bon = this.props.bon;
        const contactPersons = bon.contactPersons && bon.contactPersons
            // property alarmOnly indicates that we will only show contact persons that are NOT of type CP
            .filter(p=> !this.props.alarmOnly || (this.props.alarmOnly && p.relationCode!=='98'  && p.relationCode!=='99'))
            .map((item, index) => {
            var cp=item;
            
            if (this.props.changes.state.changedContactPersons) {
                cp=this.props.changes.state.changedContactPersons.find(p=>p.internalCode===item.internalCode) ?? cp;
            } 
            if (!cp.active) return null;

            return <div className="col-xl-6 mb-4 pe-4" key={cp.id}>
            <div>{cp.name.salutation} {cp.name.firstName} {cp.name.prefix} {cp.name.lastName}
                {cp.relationName && <span className="ms-4">(<i>{cp.relationName}</i>)</span>}
                {enableEdit && <i onClick={p=> this.edit(item)} className="fas fa-edit ms-4 clickable"></i>}
            </div>
            <div>{cp.address.street} {cp.address.streetNumber} {cp.address.building}</div>
            <div>{cp.address.zipCode} {cp.address.city}</div>
            <div>
                {cp.contact.phone1 &&
                    <Phone value={cp.contact.phone1}></Phone>
                }
            </div><div>
                {cp.contact.phone2 &&
                    <Phone value={cp.contact.phone2}></Phone>
                }
            </div>
            <div>{cp.contact.mobile &&
                <Phone value={cp.contact.mobile}></Phone>
            }
            </div>
            <div>{cp.contact.email &&
                <Email value={cp.contact.email}></Email>
            }
            </div>
        </div>});

        return <React.Fragment>
            {this.state.mode === "edit" && <div>
                <div className="edit-back"></div>

                <div className="edit-front">
                    <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.closeDetails.bind(this)}>
                        <i className="fa-sharp fa-solid fa-xmark"></i>
                    </button>

                    <EditContactPerson cp={this.state.currentEdit} 
                        changes={this.props.changes} 
                        bp={this.props.bon.serviceCall.businessPartner}
                        close={this.closeDetails.bind(this)}></EditContactPerson>
                    

                </div>
            </div>}
            
            {contactPersons && contactPersons.length>0 ?
                <React.Fragment>{contactPersons} </React.Fragment> :
                <div>Geen contactpersonen bekend</div>
            }
        </React.Fragment>
    }
}

export default ContactPersons;